import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_SITES':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_SITES':
      return Object.assign({}, state, {
        siteList: action.payload.data,
        loading: action.loading
      })
    default:
      return state
  }
}

export default reducer
